import { render, staticRenderFns } from "./Anagrafiche.vue?vue&type=template&id=206a5716&scoped=true&"
import script from "./Anagrafiche.vue?vue&type=script&lang=js&"
export * from "./Anagrafiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206a5716",
  null
  
)

export default component.exports